<span class="map-text">
  Lon: {{ currentCoordinates()?.[0] ?? 0.0 | number:'1.0-5'  }}
  Lat: {{ currentCoordinates()?.[1] ?? 0.0 | number:'1.0-5' }}
</span>
